/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Newsletter_Policy_FromInputs */

const en_why_listening_newsletter_policy_from = /** @type {(inputs: Why_Listening_Newsletter_Policy_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy brief`)
};

const es_why_listening_newsletter_policy_from = /** @type {(inputs: Why_Listening_Newsletter_Policy_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de políticas`)
};

/**
* | output |
* | --- |
* | "Policy brief" |
*
* @param {Why_Listening_Newsletter_Policy_FromInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_newsletter_policy_from = /** @type {((inputs?: Why_Listening_Newsletter_Policy_FromInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Newsletter_Policy_FromInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_newsletter_policy_from(inputs)
	return en_why_listening_newsletter_policy_from(inputs)
});